import { useFilterByCCurrencyCode } from '../../../positions/utils/cCurrency/filterByCCurrencyCode';
import { useAccountAvailableCashFieldApi } from '../api';

export const useAccountAvailableCashCCurrencyQt = () => {
  const filterPredicate = useFilterByCCurrencyCode();
  const result = useAccountAvailableCashFieldApi({
    filterPredicate,
    field: 'C_CURRENCY.QT',
  });
  return result;
};
